import { Carousel as JLDSCarousel } from "@JohnLewisPartnership/jl-design-system/dist/components/carousel/Carousel";
import { ProductCard } from "../ProductCard";
import { isInStock } from "../utils/isInStock";
import { ProductListLayout } from "@~/types/types.ts";

function validateHeadingSize(s: unknown): "small" | "large" | undefined {
  switch (s) {
    case "small":
      return "small";
    case "large":
      return "large";
    default:
      return undefined;
  }
}

export const Carousel: ProductListLayout = ({ config, products, heading }) => {
  const hideOutOfStocks = config["product-list-layout"]?.props?.hideOutOfStocks;
  const headingSize = validateHeadingSize(
    config["product-list-layout"]?.props?.headingSize,
  );

  return (
    <JLDSCarousel
      id="carousel"
      ariaLabel="carousel"
      heading={heading?.main}
      subheading={heading?.subHeading}
      headingSize={headingSize}
    >
      {products
        .filter((product) => (hideOutOfStocks ? isInStock(product) : true))
        .map((product, ind) => (
          <ProductCard
            key={
              product.advertising
                ? `${product.aliases.pimProductId}-sponsored`
                : product.aliases.pimProductId
            }
            product={product}
            config={config}
            index={ind}
          />
        ))}
    </JLDSCarousel>
  );
};
